import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import * as _ from 'lodash';

@Component({
    selector: 'project-summary-project',
    template: require('./project.summary.project.html')
})
export class ProjectSummaryProjectComponent implements OnInit {
    @Input() project: any;
    @Input() details: any;
    @Input() isOrg: boolean;
    @Input() isActive: boolean;
    @Input() isProjectMember: boolean;
    @Input() isProjectAdmin: boolean = false;
    @Input() hasUser: boolean;
    @Input() usedCategories: any[];
    @Input() useCustomHomepage: string;
    @Input() projectMenu: any;
    @Input() showCategories: boolean = false;

    requestSent: boolean = false;

    constructor(
        protected stateService: StateService, 
        
    ) {}

    ngOnInit() {
    }

    moduleAvailable(moduleName: string): boolean {
        return _.includes(_.get(this.projectMenu, 'modules', []), _.lowerCase(moduleName)) &&
            (_.get(this.projectMenu, _.lowerCase(moduleName), 0) > 0);
    }

    toggleShowCategories() {
        this.showCategories = !this.showCategories;
    }

    gotoCategory(category: any) {
        if (category.categories.length == 1) {
            this.stateService.go('home.project.trove', { selected: category.categories[0].id });
        } else {
            this.toggleShowCategories();
        }
    }
}
